export const LOGIN_PATH = '/'
export const TRAINING_REGISTER_PATH = '/register'
export const DEFAULT_PATH = '/'
export const PASSWORD_RESET_PATH = '/password_reset'
export const PASSWORD_CHANGE_PATH = '/password_change/:token'
export const APP_HEADER_TEXT = 'Anglo Training Register'



// WEBPACK FOOTER //
// ./src/constants/views.js